<template>
  <b-container fluid>

<!-- User Interface controls -->
    <template>
      <ListHeader />
    </template>
    <b-row>
      <b-col lg="6" class="my-4">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="md"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="cerca"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <h4 style="margin-top: 20px; text-align: right">CARDs: {{ header.activeCards }}</h4>
    <h4 style="margin-top: 10px; margin-bottom: 10px; text-align: right">SUBs: {{ header.activeSubs }}</h4>
    <!-- SubsItems table element -->

    <b-table
      id="my-table"
      striped
      bordered
      outlined
      hover
      sticky-header 
      :head-variant="headVariant"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      sort-icon-left
      stacked="sm"
      show-empty
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted header cell for field 'name' -->
      <!-- <template #head(selected)>
        <input type="checkbox" class="lg" @click.stop="toggleSelectAll" name="selectAll" v-model="selectAll">
      </template> -->
      <!-- <template #cell(event)="row">
        {{ row.value.device }}&{{ row.value.eventCode }}: {{ row.value.eventDesc }}
        {{ row.value.eventDesc }}
      </template> -->
      <template #cell(itemWashStatus)="row">
        {{ row.item.itemWashAct }} di {{ row.item.itemWashTot}}
      </template> 
      <template #cell(actions)="row" style="vertical-align: center">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Profilo Utente
        </b-button>
      </template>
      <!-- <template #cell(actions)="row">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Info modal
        </b-button>
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
        <router-link :to="{name: 'edit_card', params: { id: row.item.uid }}" class="icons">
          <span class="material-icons">edit</span>
        </router-link>
        <span @click.prevent="deleteCard(row.item.uid)" class="material-icons">delete</span>
      </template> -->

    </b-table>

    <h4 style="margin-top: 20px; text-align: right">CARDs Inattive: {{ header.inactiveCards }}</h4>
    <h4 style="margin-top: 10px; margin-bottom: 10px; text-align: right">SUBs Archiviate: {{ header.deactivatedSubs }}</h4>
      <!-- HistItems table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="headVariant"
      :items="histItems"
      :fields="histFields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      responsive="sm"
      table-class="w-auto" 
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(itemWashStatus)="row">
        {{ row.item.itemWashAct }} di {{ row.item.itemWashTot}}
      </template>
      <template #cell(actions)="row" style="vertical-align: center">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Profilo Utente
        </b-button>
        <span title="uploadItem" v-if="reactivateFlag(row.item, row.item._index)" class="mx-2 material-icons" @click.prevent="reactivateItem(row.item)">
          autorenew
        </span>
      </template>
    </b-table>

    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- <p>
      <b-button size="sm" @click="selectAllRows">Select all</b-button>
      <b-button size="sm" @click="clearSelected">Clear selected</b-button>
    </p>
    <p>
      Selected Rows:<br>
      {{ selected }}
    </p> -->

<!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" ok-only ok-title="CHIUDI" ok-variant="secondary" @hide="resetInfoModal">
      <template #modal-header="{ close }">
        <b-container style="margin: auto; padding: 10px; background-color: #333; color: #FFF">
          <b-row> 
            <b-col>
              <img src="../../assets/logo.png" style="width: 160px;">
            </b-col>
            <b-col style="text-align: center; margin: auto;">
              <h3 >Profilo USER</h3>
            </b-col>
            <b-col style="float: right; margin: auto;">
              <span style="float: right; margin-right: 10px;" @click="close()">X</span>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template>
        <UserDetail />
      </template>
    </b-modal>
  </b-container>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import ListHeader from '../ListHeader.vue';
  import moment from 'moment';
  import UserDetail from '../users/UserDetail.vue';
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data() {
      return {
        header: {
          activeCards: 0,
          activeSubs: 0,
          bblockedCards: 0,
          inactiveCards: 0,
          deactivatedSubs: 0,
        },
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        selectAll: false,
        row: {},
        isBusy: true,
        headVariant: 'dark',
        items: [],
        histItems: [],
        userDogs: [],
        fields: [
          { key: 'uid', label: 'UID', sortable: true, },
          //{ key: 'userRef', label: 'KEY',  sortable: true,  },
          { key: 'userFullName', label: 'Cognome Nome',  sortable: true,  },
          //{ key: 'userDisplayName', label: 'Nome Display',  sortable: false,  },
          //{ key: 'userRole', label: 'Ruolo',  sortable: true,  },
          { key: 'subsItems', label: 'Pacchetti attivi',  sortable: true,  },
          { key: 'itemDogName', label: 'Cane',  sortable: true,  },
          { key: 'itemBreedName', label: 'Razza',  sortable: true,  },
          { key: 'itemSubsName', label: 'Pacchetto',  sortable: true,  },
          { key: 'itemWashStatus', label: 'Lavaggi',  sortable: false,  },
          { key: 'itemDueDate', label: 'Scade il',  sortable: false,  },
          { key: 'cardStatus', label: 'Stato CARD',  sortable: true,  },
          /*{
            key: 'active',
            label: 'Attiva',
            // formatter: (value, key, item) => {
              formatter: (value) => {
              return value ? 'Sì' : 'No'
            },
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true
          },*/
          { key: 'actions', label: 'Azioni' }
        ],
        histFields: [
          { key: 'uid', label: 'UID', sortable: true, },
          //{ key: 'userRef', label: 'KEY',  sortable: true,  },
          { key: 'userFullName', label: 'Cognome Nome',  sortable: true,  },
          //{ key: 'userDisplayName', label: 'Nome Display',  sortable: false,  },
          //{ key: 'userRole', label: 'Ruolo',  sortable: true,  }
          { key: 'subsHistoryItems', label: 'Pacchetti Archiviati',  sortable: false,  },
          { key: 'itemDogName', label: 'Cane',  sortable: true,  },
          { key: 'itemBreedName', label: 'Razza',  sortable: true,  },
          { key: 'itemSubsName', label: 'Pacchetto',  sortable: true,  },
          { key: 'itemWashStatus', label: 'Lavaggi',  sortable: false,  },
          { key: 'itemDueDate', label: 'Scaduto il',  sortable: false,  },
          { key: 'cardStatus', label: 'Stato CARD',  sortable: true,  },
          { key: 'actions', label: 'Azioni' }
        ],
        currentPage: 3,
        perPage: 10,
        pageOptions: [10, 25, 50, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        subsItem: ['doc.data().subsItem1', 'doc.data().subsItem2', 'doc.data().subsItem3']
      }
    },
    created() {
      this.isBusy = true
      console.log('auth_user: ',  this.auth_user)
      db.collection('cards')
      .where('orgId', '==', this.auth_user.claims.orgId)
      .orderBy('fullName')
      .onSnapshot((snapshotChange) => {
        this.items = [];
        snapshotChange.forEach((doc) => {
          //console.log('card ->', doc.data())

          let cardStatus = ''
          
          if(doc.data().subsItems == 0) {
            cardStatus = 'inattiva';
            this.header.inactiveCards = this.header.inactiveCards + 1;
          } else if(doc.data().active) {
            cardStatus = 'attiva';
            this.header.activeCards = this.header.activeCards + 1;
            this.header.activeSubs = this.header.activeSubs + doc.data().subsItems;
          } else {
            cardStatus = 'bloccata';
            this.header.blockedCards = this.header.blockedCards + 1;
          }

          if(doc.data().subsHistoryItems) {
            this.header.deactivatedSubs = this.header.deactivatedSubs + doc.data().subsHistoryItems
          }

          var i;
          for (i = 0; i < doc.data().subsItems; i++) {
            let subsItemX = 'subsItem'+(i+1).toString()

            this.items.push({
              uid: doc.id,
              cardStatus: cardStatus,
              active: doc.data().active,
              userFullName: doc.data().fullName,
              //userDisplayName: doc.data().displayName,
              userRole: doc.data().role,
              userRef: doc.data().userRef,
              subsItems: doc.data().subsItems,
              itemDogName: doc.data()[subsItemX].DogName,
              itemBreedName: doc.data()[subsItemX].DogBreed,
              itemSubsName: doc.data()[subsItemX].SubsName,
              itemDueDate: doc.data()[subsItemX].DueDate,
              itemWashAct: doc.data()[subsItemX].WashAct,
              itemWashTot: doc.data()[subsItemX].WashTot,
            })
          }

          for (i = 0; i < doc.data().subsHistoryItems; i++) {
            this.histItems.push({
              uid: doc.id,
              cardStatus: cardStatus,
              active: doc.data().active,
              userFullName: doc.data().fullName,
              //userDisplayName: doc.data().displayName,
              userRole: doc.data().role,
              userRef: doc.data().userRef,
              subsHistoryItems: doc.data().subsHistoryItems,
              itemDogName: doc.data().subsHistory[i].DogName,
              itemBreedName: doc.data().subsHistory[i].DogBreed,
              itemSubsName: doc.data().subsHistory[i].SubsName,
              itemWashAct: doc.data().subsHistory[i].WashAct,
              itemWashTot: doc.data().subsHistory[i].WashTot,
              itemDueDate: doc.data().subsHistory[i].DueDate,
              _index: i,
            })
          }
        });
        this.isBusy = false
        //console.debug(this.items)
      })
    },
    computed: {
      ...mapGetters({
        // map `this.auth_user` to `this.$store.getters.user` (logged authenticated/authorized user)
        auth_user: "user",
      }),
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      totalRows() {
        return this.items.length
      }
    },
    methods: {
      addUser(){
        this.$router.push({ name: 'add_user' })
      },
      onRowSelected(items) {
        this.selected = items
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      toggleSelectAll() {
        this.selectAll = !this.selectAll
        if(this.selectAll) {
          this.selectAllRows()
        } else {
          this.clearSelected()
        }
      },
      info(item, index, button) {
        this.infoModal.title = `Profilo Utente`
        this.set_sel_user({
                  id: item.userRef,
                  fullName: item.userFullName,
               });
        console.log('sel_user ->', this.sel_user)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      reactivateItem(item) {
        db.collection('cards').doc(item.uid)
        .get()
        .then((doc) => {
          if(doc.data().subsItems==3) {
            alert('Package non recuperaile, CARD già piena')
            return
          }
          const subsItemX = 'subsItem' + (doc.data().subsItems + 1).toString()
          const subsHistoryItems = doc.data().subsHistoryItems - 1
          const subsHistory = doc.data().subsHistory
          const subsItem = subsHistory.splice(subsHistoryItems)
          console.log('subsItemX, subsHistory', subsItem[0], subsHistory)
          
          const cardUpdate = {
            active: true,
            subsItems: doc.data().subsItems + 1,
            [subsItemX]: subsItem[0],
            subsHistoryItems: subsHistoryItems,
            subsHistory: subsHistory
          }
          db.collection('cards')
          .doc(item.uid)
          .set(cardUpdate, {merge: true})
          alert('Package riattivato sulla card')
        })
        .catch((error) => {
            console.error(error);
        })
      },
      reactivateFlag(item, _index) {
        return (this.auth_user.claims.role==0 && (item.subsHistoryItems-1)==_index)
      },
      resetInfoModal() {
        this.infoModal.title = ''
      },
      deleteCard(id){
        if (window.confirm("Vuoi cancellare la CARD?")) {
          db.collection("cards").doc(id).delete().then(() => {
            console.log("CARD cancellata!");
          })
          .catch((error) => {
            console.error(error);
          })
        }
      },
      getDogs(userRef) {
        db.doc(`users/${userRef}`)
        .collection('dogs')
        .onSnapshot((snapshotChange) => {
          this.userDogs = [];
          snapshotChange.forEach((dog) => {
            console.log('dog ->', dog.data())
            this.userDogs.push({
              id: dog.id,
              name: dog.data().name,
              breedName: dog.data().breedName,
              size: dog.data().size,
              hair: dog.data().hair,
              washPgm: dog.data().washPgm,
            })
            console.log('dogs[0] ->', this.userDogs[0].name)
            //return userDogs[0].name
          })
        })
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      ...mapMutations({
        set_sel_user: 'SET_SEL_USER', // map `this.set_sel_user()` to `this.$store.commit('SET_SEL_USER')`
        set_sel_card: 'SET_SEL_CARD'
      })
    },
    filters: {
      formatDate: function(value) {
        if (!value) return
        else return moment(value, 'X', true).format("DD/MM/YY - HH:mm")
      }
    },
    components: {
      ListHeader,
      UserDetail,
    }
//});
  };
</script>